import Vue from 'vue';

const pages = require.context('@/layouts/pages/.', false, /\.vue$/);
pages.keys().forEach((fileName: string) => {
    const name = fileName?.split('/')?.pop()?.split('.');
    if (name && name?.length > 0) {
        Vue.component(`layout-page-${name[0]}`, pages(fileName).default);
    }
});
